var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content wrapper"},[_c('div',{staticClass:"body wrapper__page"},[_c('contract-history-timeline',{key:_vm.timelineKey,attrs:{"contractHistory":_vm.contractHistory}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }